module.exports = __webpack_public_path__ + "img/6.c54d350f.png";